import { MIME_TO_EXTENSION, EXTENSION_TO_FILE_PREVIEW_TYPE } from "@/constants";
import { FilePreviewType, UNSUPPORTED_FILE_TYPE } from "../types";
import { extractFileExtension } from "@/lib/file";

const getTypeFromExtension = (ext: string): FilePreviewType => {
  const type = EXTENSION_TO_FILE_PREVIEW_TYPE[ext.toLowerCase()];
  return (type || UNSUPPORTED_FILE_TYPE) as FilePreviewType;
};

export const getFilePreviewType = (
  fileUrl: string,
  fileName?: string,
  mimeType?: string,
): FilePreviewType => {
  if (mimeType) {
    const extension = MIME_TO_EXTENSION[mimeType];
    if (extension) return getTypeFromExtension(extension);
  }

  const url = fileName || fileUrl;
  if (!url) return UNSUPPORTED_FILE_TYPE;

  const ext = extractFileExtension(url);
  return getTypeFromExtension(ext);
};
